import { useCallback, useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { FetchResult } from '@apollo/client';
import {
  DisconnectUserCollectorInput,
  DisconnectUserCollectorMutation,
  useDisconnectUserCollectorMutation
} from 'graphql/types';
export const useDisconnectUserCollector = (): {
  disconnectUserCollector: (
    input: DisconnectUserCollectorInput
  ) => Promise<
    FetchResult<
      DisconnectUserCollectorMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    disconnectUserCollectorMutation,
    { loading, error }
  ] = useDisconnectUserCollectorMutation();
  const disconnectUserCollector = useCallback(
    async (input: DisconnectUserCollectorInput) =>
      await disconnectUserCollectorMutation({
        variables: {
          input
        }
      }),
    [disconnectUserCollectorMutation]
  );

  return useMemo(
    () => ({
      disconnectUserCollector,
      loading,
      error
    }),
    [disconnectUserCollector, loading, error]
  );
};
